export function doesAccountRequireCompletion(user = {}) {
  return !user.email || !user.fullname;
}
